export const USER_FIELD_FIRST_NAME = 'first_name';
export const USER_FIELD_LAST_NAME = 'last_name';
export const USER_FIELD_MIDDLE_NAME = 'middle_name';
export const USER_FIELD_USER_NAME = 'username';
export const USER_FIELD_PASSWORD = 'password';
